import React, { FC, useState } from 'react';
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  flexRender,
} from '@tanstack/react-table';
import { columns } from 'constants/flight';
import { FlightResult } from 'ts/flight/interfaces/FlightSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpWideShort, faArrowUpShortWide } from '@fortawesome/free-solid-svg-icons';
import { faArrowUpArrowDown } from '@fortawesome/sharp-duotone-solid-svg-icons';

interface FlightResultsTableProps {
  data: FlightResult[];
  onRowClick?: (flightId: string) => void;
  selectedFlId?: string;
  shortTable?: boolean;
}

export const FlightResultsTable: FC<FlightResultsTableProps> = ({
  data,
  onRowClick,
  selectedFlId,
  shortTable = true,
}) => {
  const [sorting, setSorting] = useState<SortingState>([]);

  const table = useReactTable({
    data,
    columns: shortTable ? columns.slice(0, -5) : columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <div className="fl-pair-table">
      <div className="table-container">
        <table>
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id} onClick={header.column.getToggleSortingHandler()}>
                    {flexRender(header.column.columnDef.header, header.getContext())}
                    <span className="sort-icon">
                      {{
                        asc: (
                          <FontAwesomeIcon
                            icon={faArrowUpShortWide as any}
                            style={{ color: 'var(--color-400)' }}
                          />
                        ),
                        desc: (
                          <FontAwesomeIcon
                            icon={faArrowUpWideShort as any}
                            style={{ color: 'var(--color-400)' }}
                          />
                        ),
                      }[header.column.getIsSorted() as string] ?? (
                        <FontAwesomeIcon
                          icon={faArrowUpArrowDown as any}
                          style={{ color: 'var(--color-300)' }}
                        />
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr
                key={row.id}
                onClick={() => onRowClick?.(row.original.id)}
                className={row.original.id === selectedFlId ? 'active' : ''}
              >
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FlightResultsTable;
